module.exports = __webpack_public_path__ + "static/media/arrow-triangle-fill-down.87295198.svg";